import React from 'react'
import Modal from 'modals/dialog'
import UsersClientStateProvider from 'state/users'
import { cls } from 'utilities/dom'
import { PickerContent } from 'modals/s'
import PeoplePickerContent from './content'

const PeoplePicker = ({ show = false, method = 'add', dismiss, className, salt, ...props }) => {
    salt = `modal:people-picker:${salt}`
    const namespace = `${salt}:filter`

    className = cls([
        className,
        method
    ])

    return (
        <Modal
            show={show}
            dismiss={dismiss}
            contentWrapper={PickerContent}
            contentClassName={className}
            key={salt}>
            <PeoplePickerContent
                {...props}
                method={method}
                namespace={namespace}
                salt={salt} />
        </Modal>
    )
}

export default ({ query, ...props }) => (
    <UsersClientStateProvider
        {...query}
        queryOptions={{ enabled: !props.fixed && !!query?.preload }}>
        <PeoplePicker {...props} />
    </UsersClientStateProvider>
)